module.exports = __webpack_public_path__ + "d49b20f216db205b4adeea6147aca99f.pdf";